var render, staticRenderFns
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=5ad8d4ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8d4ad",
  null
  
)

export default component.exports